import { g as t } from "./index793.mjs";
import { i as a } from "./index761.mjs";
import { o as e } from "./index839.mjs";
import { u as i } from "./index826.mjs";
var l = t, m = a, s = e, b = i, p = Object, v = b ? function(o) {
  return typeof o == "symbol";
} : function(o) {
  var r = l("Symbol");
  return m(r) && s(r.prototype, p(o));
};
export {
  v as i
};
